module.exports = __webpack_public_path__ + "static/visionar_augmented_reality_top-10-ar-sdk_792-352-1-fe78b64bf86f63afaadf1e54c91e7bb7.jpg";